import DOMPurify from 'dompurify';

// Central HTML sanitiser. Email bodies, signatures and AI output are all
// attacker-influenced, so every dangerouslySetInnerHTML sink MUST route through
// this. It strips scripting vectors while keeping normal rich-text/email markup.
const CONFIG = {
  USE_PROFILES: { html: true },
  FORBID_TAGS: ['script', 'style', 'iframe', 'object', 'embed', 'form', 'base', 'link', 'meta'],
  FORBID_ATTR: ['onerror', 'onload', 'onclick', 'onmouseover', 'onfocus', 'onblur', 'srcdoc', 'formaction'],
  ALLOW_DATA_ATTR: false,
};

// Force any surviving anchors to open safely: no reverse-tabnabbing, no
// same-tab navigation away from the app.
if (typeof window !== 'undefined' && DOMPurify.isSupported) {
  DOMPurify.addHook('afterSanitizeAttributes', (node) => {
    if (node.tagName === 'A') {
      node.setAttribute('target', '_blank');
      node.setAttribute('rel', 'noopener noreferrer nofollow');
    }
  });
}

export function sanitizeHtml(dirty) {
  if (dirty == null || dirty === '') return '';
  return DOMPurify.sanitize(String(dirty), CONFIG);
}

// Convenience for the dangerouslySetInnerHTML prop: returns { __html } or
// undefined when there's nothing to render.
export function safeHtml(dirty) {
  const clean = sanitizeHtml(dirty);
  return clean ? { __html: clean } : undefined;
}

export default sanitizeHtml;
